var _styled;

import styled from 'react-emotion';
import { MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
var TopNavInner = styled('div')((_styled = {
  display: 'flex',
  flexDirection: 'column',
  width: "calc(100% - " + SPACING.SCALE_3 + ")",
  maxWidth: '960px',
  padding: SPACING.SCALE_2 + " " + SPACING.SCALE_3,
  boxSizing: 'border-box'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  padding: SPACING.SCALE_2 + " 0",
  flexDirection: 'row',
  width: "calc(100% - " + SPACING.SCALE_6 + ")"
}, _styled));
export default TopNavInner;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/top-nav-inner/index.js
// module id = 110
// module chunks = 0